import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Sms = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/sms">
        <g id="sms">
          <path
            id="Vector"
            d="M11.332 14.1667H4.66536C2.23203 14.1667 0.832031 12.7667 0.832031 10.3334V5.66671C0.832031 3.23337 2.23203 1.83337 4.66536 1.83337H11.332C13.7654 1.83337 15.1654 3.23337 15.1654 5.66671V10.3334C15.1654 12.7667 13.7654 14.1667 11.332 14.1667ZM4.66536 2.83337C2.7587 2.83337 1.83203 3.76004 1.83203 5.66671V10.3334C1.83203 12.24 2.7587 13.1667 4.66536 13.1667H11.332C13.2387 13.1667 14.1654 12.24 14.1654 10.3334V5.66671C14.1654 3.76004 13.2387 2.83337 11.332 2.83337H4.66536Z"
          />
          <path
            id="Vector_2"
            d="M7.9992 8.57998C7.4392 8.57998 6.87254 8.40665 6.4392 8.05331L4.35253 6.38665C4.1392 6.21331 4.0992 5.89998 4.27254 5.68665C4.44587 5.47331 4.75921 5.43332 4.97254 5.60665L7.0592 7.27332C7.56587 7.67998 8.42586 7.67998 8.93253 7.27332L11.0192 5.60665C11.2325 5.43332 11.5525 5.46665 11.7192 5.68665C11.8925 5.89998 11.8592 6.21998 11.6392 6.38665L9.55254 8.05331C9.12587 8.40665 8.5592 8.57998 7.9992 8.57998Z"
          />
        </g>
      </g>
    </svg>
  );
};

Sms.displayName = 'Sms';
